import { lazy } from "react";
import { PATHS } from "@/lib/router";

const TargetSetupPage = lazy(() => import("./pages/TargetSetupPage"));
const TargetSetupOverviewPage = lazy(
  () => import("./pages/TargetSetupOverviewPage"),
);

export const targetSetupRoutes = [
  {
    path: PATHS.TARGET_SETUP,
    element: <TargetSetupPage />,
    handle: { permission: { resource: "target_setting", action: "view" } },
  },
  {
    path: PATHS.TARGET_SETUP_OVERVIEW,
    element: <TargetSetupOverviewPage />,
    handle: { permission: { resource: "target_setting", action: "view" } },
  },
];
